import Component from 'vue-class-component';
import BaseComponent from "@/components/base/BaseComponent";
import {DataItem, Downloadable} from "@/models/general";

@Component({})
export default class InfographicComponent extends BaseComponent implements Downloadable {

download(mode: string,dataItem?:DataItem){

}


}
